import React, { useState } from 'react';

import { Trans, useTranslation } from 'react-i18next';

import { Copy, Loader2 } from 'lucide-react';



type ChannelMethod = 'telegram' | 'bale';



interface ChannelBotDesktopLinkPanelProps {

  method: ChannelMethod;

  deepLink: string;

  polling?: boolean;

  linkWaitExpired?: boolean;

  showLocalhostHint?: boolean;

  checkDisabled?: boolean;

  onCheckLink?: () => void;

}



export const ChannelBotDesktopLinkPanel: React.FC<ChannelBotDesktopLinkPanelProps> = ({

  method,

  deepLink,

  polling = false,

  linkWaitExpired = false,

  showLocalhostHint = false,

  checkDisabled = false,

  onCheckLink

}) => {

  const { t } = useTranslation('settings');

  const [copied, setCopied] = useState(false);

  const qrSrc = `https://api.qrserver.com/v1/create-qr-code/?size=140x140&data=${encodeURIComponent(deepLink)}`;

  const channelLabel =

    method === 'telegram' ? t('security.methodTelegram') : t('security.methodBaleShort');



  const copyLink = async () => {

    try {

      await navigator.clipboard.writeText(deepLink);

      setCopied(true);

      window.setTimeout(() => setCopied(false), 2500);

    } catch {

      setCopied(false);

    }

  };



  return (

    <div className="rounded-lg border border-teal-200/90 bg-teal-50/70 p-3 dark:border-teal-900/50 dark:bg-teal-950/25">

      <p className="text-xs font-semibold text-teal-900 dark:text-teal-100">

        {t('security.desktopChannelHintTitle')}

      </p>

      <p className="mt-1 text-[11px] text-slate-600 dark:text-slate-400">

        <Trans

          i18nKey="security.desktopChannelHintBody"

          ns="settings"

          values={{ channel: channelLabel }}

          components={{ strong: <strong /> }}

        />

      </p>

      {showLocalhostHint && (
        <div className="mt-2 flex flex-wrap items-start gap-2 rounded-lg border border-dashed border-amber-400/80 bg-amber-50/60 px-2.5 py-2 dark:border-amber-700/60 dark:bg-amber-950/20">
          <span className="shrink-0 rounded bg-amber-200 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide text-amber-950 dark:bg-amber-800 dark:text-amber-50">
            {t('security.developmentOnlyBadge')}
          </span>
          <p className="min-w-0 flex-1 text-[11px] text-amber-950 dark:text-amber-100">
            {t('security.localhostBotLinkHint', { channel: channelLabel })}
          </p>
        </div>
      )}

      <div className="mt-3 flex flex-col items-center gap-2 sm:flex-row sm:items-start">

        <img

          src={qrSrc}

          width={140}

          height={140}

          alt=""

          className="rounded-lg border border-white bg-white p-1 shadow-sm dark:border-gray-700 dark:bg-gray-900"

        />

        <div className="flex min-w-0 flex-1 flex-col gap-2 text-center sm:text-start">

          <p className="text-[11px] text-slate-600 dark:text-slate-400">

            {t('security.desktopChannelQrCaption')}

          </p>

          <button

            type="button"

            onClick={() => void copyLink()}

            className="inline-flex items-center justify-center gap-1.5 rounded-lg border border-slate-300 bg-white px-3 py-1.5 text-xs font-medium text-slate-700 hover:bg-slate-50 dark:border-gray-600 dark:bg-gray-800 dark:text-slate-200 dark:hover:bg-gray-700"

          >

            <Copy className="h-3.5 w-3.5" />

            {copied ? t('security.botLinkCopied') : t('security.copyBotLink')}

          </button>

          {onCheckLink && (

            <button

              type="button"

              disabled={checkDisabled || polling}

              onClick={onCheckLink}

              className="inline-flex items-center justify-center gap-1.5 rounded-lg border border-teal-600 bg-teal-600 px-3 py-1.5 text-xs font-semibold text-white hover:bg-teal-700 disabled:opacity-60"

            >

              {polling ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : null}

              {polling

                ? method === 'telegram'

                  ? t('security.waitingInTelegram')

                  : t('security.waitingInBale')

                : t('security.checkBotLinkStatus')}

            </button>

          )}

          <a

            href={deepLink}

            target="_blank"

            rel="noreferrer"

            className="break-all text-[11px] text-teal-700 underline dark:text-teal-400"

          >

            {deepLink}

          </a>

          {linkWaitExpired && !polling && (

            <p className="text-[11px] text-amber-800 dark:text-amber-200">{t('security.linkTimedOut')}</p>

          )}

        </div>

      </div>

    </div>

  );

};


